export default __webpack_public_path__ + "static/media/person_remove_black_24dp.ab0ce345.svg";